import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import { SHARE, SHARE_SUCCESS, SHARE_ERROR } from "./messageTypes";
const share = navigator && navigator.share;

if (share) {
  onMessageFromWebApp(SHARE, async ({ title, text, url }) => {
    try {
      await share({ title, text, url });
      sendMessageToWebApp(SHARE_SUCCESS);
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(SHARE_ERROR, error);
    }
  });
}
